import { render, staticRenderFns } from "./asideBar.vue?vue&type=template&id=48227a1c&scoped=true"
import script from "./asideBar.vue?vue&type=script&lang=js"
export * from "./asideBar.vue?vue&type=script&lang=js"
import style0 from "./asideBar.vue?vue&type=style&index=0&id=48227a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48227a1c",
  null
  
)

export default component.exports